import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React from 'react';
import PropTypes from 'prop-types';
import NormalTable from './Table';
import ResizableTable from './ResizableTable';
import Column from './Column';
import { strings } from '@douyinfe/semi-foundation/lib/es/table/constants';

class Table extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getCurrentPageData = () => this.tableRef.current && this.tableRef.current.getCurrentPageData();

    this.tableRef = /*#__PURE__*/React.createRef();
  }

  render() {
    // eslint-disable-next-line prefer-destructuring
    const props = this.props;

    if (props.resizable) {
      return /*#__PURE__*/React.createElement(ResizableTable, _Object$assign({}, props, {
        ref: this.tableRef
      }));
    } else {
      return /*#__PURE__*/React.createElement(NormalTable, _Object$assign({}, props, {
        ref: this.tableRef
      }));
    }
  }

}

Table.Column = Column;
Table.DEFAULT_KEY_COLUMN_SELECTION = strings.DEFAULT_KEY_COLUMN_SELECTION;
Table.DEFAULT_KEY_COLUMN_EXPAND = strings.DEFAULT_KEY_COLUMN_EXPAND;
Table.propTypes = _Object$assign(_Object$assign({}, NormalTable.propTypes), {
  resizable: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
});
Table.defaultProps = {
  hideExpandedColumn: true
};
export * from './interface';
export default Table;